<template>
    <div class="md-content broker-web-content md-content-web-content" v-if="list.length > 0">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            ref="content"
        >
            <div
                :class="['row', item.imgAlign]"
                v-for="(item, index) in list"
                :key="index"
                :style="{ backgroundColor }"
            >
                <div class="text-content">
                    <div class="text-wrap">
                        <div
                            class="title mg-title"
                            v-html="item.title"
                        ></div>
                        <div class="desc" v-html="item.desc"></div>
                    </div>
                </div>
                <div
                    class="img-wrap"
                    :style="{
                        minHeight: calcHeight,
                        maxHeight: calcHeight,
                        backgroundColor
                    }"
                >
                    <site-img
                        :size="1200"
                        :src="item.img"
                        :style="{ objectFit: fitStyle, backgroundColor }"
                    />
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>


import common from '../index';

import global from '../../../common/global';

export default {
    mixins: [common],
    data: function() {
        return {
            currentWidth: window.innerWidth,
            backgroundColor: '',
            calcHeight: '',
            fitStyle: 'cover'
        };
    },
    mounted() {
        this.calcStyle(true);
        global.resize(this.calcStyle);
    },
    computed: {
        
        isMobile() {
            return this.currentWidth <= 800;
        }
    },
    methods: {
        //  This method is in config.js call in ， calculate actual size
        calcRealSize() {
            let ele = this.$refs.content.$el;
            const sizeOption = this.sizeOption || {};
            let { type, ratio, height } = this.sizeOption || {};
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            if (ele) {
                if (type === 'scale') {
                    ratio = (ele.offsetHeight / ele.offsetWidth) * 100;
                } else if (type === 'height') {
                    height = ele.offsetHeight;
                }
            }
            return {
                type: sizeOption.type,
                mobileType: sizeOption.mobileType,
                ratio: this.isMobile ? sizeOption.ratio : ratio,
                mobileRatio: this.isMobile ? ratio : sizeOption.mobileRatio,
                height: this.isMobile ? sizeOption.height : height,
                mobileHeight: this.isMobile ? height : sizeOption.mobileHeight
            };
        },
        calcStyle() {
            this.currentWidth = window.innerWidth;
            let ele = this.$refs.content.$el;
            const sizeOption = this.sizeOption || {};
            let { type, ratio, height } = this.sizeOption || {};
            let calcHeight = '';
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            if (type === 'scale') {
                calcHeight = (ele.offsetWidth * ratio) / 100 + 'px';
            } else if (type === 'fullScreen') {
                calcHeight = '';
                // Math.max(window.innerHeight - this.$el.offsetTop, 500) +
                // 'px';
            } else if (type === 'height') {
                calcHeight = height + 'px';
            }
            console.log(calcHeight);
            this.calcHeight = calcHeight;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-content.md-content-web-content {
    width: 100vw;
    .mg-container {
        width: 100vw;
    }
    .mg-title {
        max-width: 100%;
    }
    .row {
        display: flex;
        flex-direction: row-reverse;
        &:nth-child(2n + 1) {
            flex-direction: row;
        }
        &.auto {
        }
        &.left {
            flex-direction: row-reverse !important;
        }
        &.right {
            flex-direction: row !important;
        }
        .text-content {
            flex: 1;
            max-width: 50%;
            .text-wrap {
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 50px;
                height: 100%;
                .desc {
                    font-size: 14px;
                    color: var(--color-title);
                    line-height: 20px;
                }
            }
        }
        .img-wrap {
            flex: 1;
            max-width: 50%;
            img {
                width: 100%;
                height: 100%;
            }
        }
        @include media-800 {
            &,
            &:nth-child(2n + 1) {
                flex-direction: column-reverse;
            }
            &.left {
                flex-direction: column-reverse !important;
            }
            &.right {
                flex-direction: column-reverse !important;
            }
            .text-content,
            .img-wrap {
                width: 100vw;
                max-width: 100%;
                flex: none;
            }
            & .text-content .text-wrap {
                padding: 20px 15px 25px;
            }
        }
    }
}
</style>
